import { Component, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-load',
  templateUrl: './load.component.html',
  styleUrls: ['./load.component.css']
})
export class LoadComponent implements OnDestroy {

  constructor() {}

  ngOnDestroy() {}

}
